<template>
  <div>
    <div v-if="product.rating" class="rating-summary">
      <span
        class="stars"
        :style="`--rating: ${product.rating.toFixed(1)};`"
        :aria-label="`Rating of this product is ${product.rating.toFixed(
          1,
        )} out of 5.`"
      ></span>
      <span class="count"
        >{{ product.rating.toFixed(1) }} {{ ratingSummary }}</span
      >
    </div>
    <ul class="member-ratings">
      <li
        v-for="member_review in expanded ? reviews : product.member_reviews"
        :key="member_review.id"
      >
        <span
          class="stars"
          :style="`--rating: ${parseFloat(member_review.user_rating).toFixed(
            1,
          )};`"
          :aria-label="`Rating of this product is ${parseFloat(
            member_review.user_rating,
          ).toFixed(1)} out of 5.`"
        ></span>
        <h2>
          {{ member_review.user_name }} -
          {{ formatDate(member_review.date_created) }}
        </h2>
        <p>{{ member_review.user_review }}</p>
      </li>
    </ul>
    <p v-if="showMoreLink">
      <button class="read-all button-link" @click="expand">
        Read all reviews
      </button>
    </p>
    <PaginationControlsAction
      v-else
      :current-page-number="currentPage"
      :total-pages="pageCount"
      @setPage="setPage"
    />
  </div>
</template>

<script>
import { getMemberReviews } from '#wa/services/memberReviewsServices'

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    dateFormat: {
      type: String,
      default: 'MMMM D, YYYY',
    },
  },
  data() {
    return {
      expanded: false,
      currentPage: 1,
      pageSize: 5,
      reviews: [],
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.product.member_reviews_count / this.pageSize)
    },
    ratingSummary() {
      let summary = ''
      if (this.product.rating_count) {
        summary += ` - ${this.product.rating_count} ${
          this.product.rating_count === 1 ? 'rating' : 'ratings'
        } `
      }

      summary += `(${this.product.member_reviews_count} ${
        this.product.member_reviews_count === 1
          ? 'written review'
          : 'written reviews'
      })`

      return summary
    },
    showMoreLink() {
      return !this.expanded && this.product.member_reviews_count > 2
    },
  },
  watch: {
    currentPage: 'fetchReviews',
  },
  async mounted() {
    await this.fetchReviews()
  },
  methods: {
    /**
     * @param {string} dateString
     */
    formatDate(dateString) {
      return moment(dateString).format(this.dateFormat)
    },
    setPage(page) {
      this.currentPage = page
    },
    expand() {
      this.expanded = true
    },
    async fetchReviews() {
      this.reviews = await getMemberReviews(
        this.$axios,
        this.product,
        this.currentPage,
      )
    },
  },
}
</script>
